interface IReasonTag {
    id: string;
    name: string;
}

const REASON_TAGS: IReasonTag[] = [
    {
        id: 'Limited Availability',
        name: 'Event or Section TSO, High PO rate event'
    },
    {
        id: 'Unable to Process',
        name: 'Too many failed attempts'
    },
    {
        id: 'Listing Issue',
        name: 'Mapping issue, PPE, Postponed/TBA, Unclear Delivery'
    }
];

const insertBreakPoints = (str: string, size: number): string => {
    if (!str) return '';
    return str.match(new RegExp(`.{1,${size}}`, 'g'))?.join('\u200B') ?? str;
};

export {
    REASON_TAGS,
    insertBreakPoints
};
